import React from "react";
import { Link } from "react-router-dom";
import GalleryData from "../Gallery.json";

function GalleryCarousel() {
	const gotoTop = () => {
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	};

	// Get a selection of new images for the home page
	const displayImages = GalleryData.Recent_Updates.slice(0, 12);

	return (
		<div className="ModernGallerySection" data-aos="fade-up">
			<div id="Heading" data-aos="fade-up">
				<h1>Recent Highlights</h1>
			</div>

			<div className="GalleryGrid">
				{displayImages.map((item, index) => (
					<div
						className={`GalleryItem item-${index % 6}`}
						key={index}
						data-aos="zoom-in"
						data-aos-delay={index * 100}
					>
						<img src={item.img} alt={`Highlight ${index}`} Loading="lazy" style={{ objectPosition: item.position || 'center' }} />
						<div className="ImageOverlay">
							<span className="OverlayText">Campus Life</span>
						</div>
					</div>
				))}
			</div>

			<div className="GalleryActions" data-aos="fade-up">
				<Link
					to="/gallery"
					className="ViewAllBtn"
					onClick={gotoTop}
				>
					Explore Full Gallery →
				</Link>
			</div>
		</div>
	);
}

export default GalleryCarousel;
